import { render, staticRenderFns } from "./invoice.vue?vue&type=template&id=9fad1df2"
import script from "./invoice.ts?vue&type=script&lang=js&external"
export * from "./invoice.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports